import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { openSubscriptionPortal } from '../../api/subscriptions';
import { useAuth } from '../../context/AuthContext';
import AppButton from '../common/AppButton';

export default function SubscriptionBillingActions({
  disabled = false,
  managementPage = false,
}: {
  disabled?: boolean;
  managementPage?: boolean;
}) {
  const { company, hasPermission } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (
    !company ||
    !hasPermission('canManageSubscription') ||
    company.subscription?.store !== 'stripe'
  )
    return null;
  if (!managementPage)
    return (
      <div className="mt-6">
        <AppButton
          variant="tertiary"
          disabled={disabled}
          onClick={() => navigate('/subscription/manage')}
        >
          Manage subscription
        </AppButton>
      </div>
    );
  const run = async (action: (companyId: string) => Promise<void>) => {
    if (busy || disabled) return;
    setBusy(true);
    try {
      await action(company.id);
    } catch (cause) {
      toast.error(
        cause instanceof Error
          ? cause.message
          : 'Unable to open billing. Please try again.'
      );
      setBusy(false);
    }
  };
  return (
    <div className="mt-6 flex flex-col gap-3">
      <AppButton
        variant="secondary"
        disabled={busy || disabled}
        onClick={() => void run(openSubscriptionPortal)}
      >
        Payment methods and invoices
      </AppButton>
    </div>
  );
}
